"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
const react_1 = __importStar(require("react"));
const native_1 = require("styled-components/native");
const S = __importStar(require("./SearchBar.styles"));
const Atoms_1 = require("../../Atoms");
let timeout;
exports.debounce = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
        func();
    }, delay);
};
exports.default = (props) => {
    const [value, setValue] = react_1.useState('');
    const { showFilter = true, placeholder, accessibilityLabel, accessibilityHint, onVoicePress, onFilterPress, onCancelPress = () => { }, onChangeText = () => { }, onFocus = () => { }, showVoice = false, showSearchIcon = false, staticValue, selectedChargepointId, searchBarRef, filtersActive = false, filtersEnabled = false, } = props;
    const theme = native_1.useTheme();
    return (react_1.default.createElement(S.SearchBarContainer, { testID: "AddressSearchBar", accessibilityLabel: "AddressSearchBar", accessibilityHint: "Search for an address" },
        showVoice && (react_1.default.createElement(S.ImageView, { onPress: onVoicePress, testID: "VoicePress" },
            react_1.default.createElement(Atoms_1.VoiceIcon, { color: theme.searchBar.icons, width: 16, height: 33 }))),
        showSearchIcon && (react_1.default.createElement(S.ImageView, null,
            react_1.default.createElement(Atoms_1.SearchIcon, { color: theme.searchBar.icons, width: 20, height: 20 }))),
        react_1.default.createElement(S.SearchBar, { ref: searchBarRef, placeholder: placeholder, value: staticValue || value, returnKeyType: "search", onFocus: onFocus, onChangeText: (text) => {
                setValue(text);
                exports.debounce(() => onChangeText(text, selectedChargepointId), 250);
            }, testID: "SearchBar", accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, placeholderTextColor: theme.searchBar.placeholderText }),
        (value.length > 0 || (!!staticValue && staticValue.length > 0)) && (react_1.default.createElement(S.ImageView, { testID: "Clear search", accessibilityLabel: "Clear Search", accessibilityHint: "Clear text from search box", onPress: (e) => {
                onCancelPress(e);
                setValue('');
            } },
            react_1.default.createElement(Atoms_1.CloseIcon, { color: theme.searchBar.icons }))),
        showFilter && (react_1.default.createElement(S.ImageView, { accessibilityLabel: "map filters", accessibilityHint: "Apply filters to your location search", accessibilityRole: "button", onPress: onFilterPress, testID: "FilterPress" },
            !!filtersEnabled && (react_1.default.createElement(Atoms_1.FilterIcon, { color: theme.searchBar.icons, width: 20, height: 20 })),
            filtersActive && (react_1.default.createElement(S.FilterNotification, null,
                react_1.default.createElement(Atoms_1.Dot, { active: filtersActive })))))));
};
